import { SignInHandlerParametersInterface } from './types'

import { postFormData } from '../../../utils'
import { API_AUTH_BASE_PATH, API_AUTH_SIGNIN } from '../constants'

export const signInHandler = async (user: SignInHandlerParametersInterface) => {
  await postFormData<SignInHandlerParametersInterface, Response>(`${API_AUTH_BASE_PATH}/${API_AUTH_SIGNIN}`, user)
}
